import axios from "../../config/axios";
import config from "../../config/index";
const dataconnection = {
    addConnection: (params) =>
        axios
            .post(`${config.apiBaseURL2}database-connection`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    getConnectionList: (params) =>
        axios
            .get(`${config.apiBaseURL2}database-list`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    updateConnection: (params) =>
        axios
            .post(`${config.apiBaseURL2}database-update`,params )
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    deleteConnection: (params) =>
        axios
            .post(`${config.apiBaseURL2}database-delete/${params}`)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    testConnection: (params) =>
        axios
            .post(`/dataconnection/DataConnection/testConnection`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    getConnectionDetails: (params) =>
        axios
            .post(`/dataconnection/DataConnection/getConnectionDetails`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    addDataApiConnection: (params) =>
        axios
            .post(`${config.apiBaseURL2}dataApi-connection`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    getDataApiConnectionList: (params) =>
        axios
            .get(`${config.apiBaseURL2}dataApi-connection`)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    editDataApiConnection: (id,params) =>
        axios
            .put(`${config.apiBaseURL2}dataApi-connection/${id}`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    deleteDataApiConnection: (id) =>
        axios
            .delete(`${config.apiBaseURL2}dataApi-connection/${id}`)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    duplicateDataApiConnection: (id) =>
                axios
                    .put(`${config.apiBaseURL2}duplicate-config/${id}`)
                    .then((resp) => resp.data)
                    .catch((err) => console.log(err)),
    testRequest: (params) =>
        axios
            .post(`${config.apiBaseURL2}sendRequest`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),        
};

export default dataconnection;
